import { List } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";

const FixedSizeListComponent = (props) => {
  const { rows } = props;

  return (
    <List
      sx={{
        width: "100%",
        maxHeight: 360,
        maxWidth: 360,
        bgcolor: "background.paper",
        overflow: "auto",
        justifyContent: "start",
      }}
    >
      {rows &&
        rows.map((value) => (
          <ListItem key={value} component="div" disablePadding>
            <ListItemText primary={`${value}`} />
          </ListItem>
        ))}
    </List>
  );
};

export default FixedSizeListComponent;
